export default __webpack_public_path__ + "static/media/dc-transparent.4f41f288.gif";